/*
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
*/
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from '@environment';

@Component({
  selector: 'wsn-home-layout',
  templateUrl: './home-layout.component.html',
  styleUrls: ['./home-layout.component.scss']
})
export class HomeLayoutComponent implements OnInit {
  readonly banner = environment.banner;
  readonly bannerKey = `gallery_banner_v${environment.banner.version}`;
  showBanner = false;

  @ViewChild('sidenavWrapper', { static: true }) sidenavWrapper: ElementRef<HTMLElement>;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.showBanner = !localStorage.getItem(this.bannerKey);
    this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe(() => {
      if (this.sidenavWrapper?.nativeElement) {
        this.sidenavWrapper.nativeElement.scrollTop = 0;
      }
    });
  }

  dismissBanner(): void {
    localStorage.setItem(this.bannerKey, '1');
    this.showBanner = false;
  }
}
